import { db } from '../firebase';
import { toast } from 'react-toastify';


const deleteUser = async (userId) => {
  let error;
  const collectionRef = db.collection('users').doc(userId)
  try {
    collectionRef.delete().then(()=>{
        console.log('Successfully removed user')
        toast.info("User successfully deleted");

    });
  } catch (error) {
    console.log(error)
  }

  return { error };
}

export default deleteUser;